import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteJobFamilyModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteJobFamilyModalContainer" */
      './DeleteJobFamilyModalContainer'
    ),
  loading: LoadingModal,
});
